export default {"src":"/_next/static/media/gst-search-icon.68ce9e72.svg","height":34,"width":34};